{
  "hero": {
    "heading": "Your school year, already filled in.",
    "description": "A digital and printable planner with your district dates already filled in.",
    "checks": [
      "No-school days, already shaded.",
      "Printable PDF to fill in your own dates.",
      "12 months. 52 weeks. Done for you."
    ],
    "secondary_cta": "View Calendar Events",
    "planner_image_alt": "Planner — monthly and weekly pages"
  },
  "benefits": {
    "eyebrow": "What's inside",
    "heading": "Every date. Already there.",
    "items": [
      {
        "eyebrow": "Already filled in",
        "title": "Every district calendar date.",
        "body": "Holidays, PD days, early dismissals, the first day, the last day. We've added them all so you don't have to."
      },
      {
        "eyebrow": "Print at home",
        "title": "On your fridge in 5 minutes.",
        "body": "High-resolution PDF that prints beautifully on any home printer. Print the whole year or just next week."
      },
      {
        "eyebrow": "Yours forever",
        "title": "Access any time.",
        "body": "If you report a district date change, we update your planner. Spilled juice on August? Reprint the page."
      }
    ]
  },
  "faq": {
    "eyebrow": "Common questions",
    "heading": "Anything else?",
    "items": [
      {
        "question": "Can I print this from home?",
        "answer": "Yes. You'll receive two printables: a 12-month printable and a 52-week printable. Print both, or either, right from home."
      },
      {
        "question": "What size is the printable?",
        "answer": "The printable planner is designed to fit on standard 8.5×11 paper, making it easy to print from home or work."
      },
      {
        "question": "Can I access the planner online?",
        "answer": "Yes, you can access an interactive version of the planner online anytime. Quickly scroll through weeks and months."
      },
      {
        "question": "What if the district dates change?",
        "answer": "Most district calendars are board-approved once a year, with little changes once made. However, if you report district date changes, we'll update the planner, and you can print it again, for free. You're welcome to email support@agendahero.com with any changes."
      },
      {
        "question": "Can I add my own dates to it?",
        "answer": "Yes. Add your own dates like birthdays, practices, and appointments right in the online planner, and they'll print alongside the district dates."
      },
      {
        "question": "Why is it free?",
        "answer": "We believe no parent, teacher, or staff should have to duplicate the work of each other just to know the school days off. This is our way of showing the world what's possible.\n\nAgenda Hero is the most-loved product our team has ever worked on. We know that once you try it, you'll love it too."
      },
      {
        "question": "Can my school use this?",
        "answer": "Agenda Hero works with schools to provide a streamlined way of communicating every important event from days off to field trips to PTA meetings. Email schools@agendahero.com for more info."
      },
      {
        "question": "Do you partner with PTAs/PTOs?",
        "answer": "Yes. We partner with PTAs, districts, and schools to keep the schedule up to date. Email schools@agendahero.com to learn more."
      },
      {
        "question": "Do you have educator discounts?",
        "answer": "This printable is free, but we do have paid offerings beyond the printable. If you are an educator, email schools@agendahero.com and we'll provide you with an educator discount code for teachers and staff."
      },
      {
        "question": "Why did you create Agenda Hero?",
        "answer": "We're parents who were spending way too much time figuring out who had to be where and when. We wanted to solve this problem for ourselves, and everyone else, too.\n\nWe have a simple philosophy: Why should every parent, teacher, or staff have to duplicate manual, tedious calendar efforts when one person can create the schedule, and everyone can benefit?"
      }
    ]
  },
  "final_cta": {
    "heading": "More time for joy.",
    "description": "12 Months. 52 Weeks. Done for You.",
    "price_line": "No purchase required · Reprint all year"
  },
  "footer": {
    "help": "Help",
    "terms": "Terms",
    "privacy": "Privacy"
  },
  "checkout": {
    "label_paid": "Get printable • ${{price}}",
    "label_free": "Get Free Printable",
    "cta_aria": "Get your planner"
  }
}
